// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container__19353","image":"ErrorPage_image__I6LLD","text_404":"ErrorPage_text_404__1eO_o","text_error":"ErrorPage_text_error__17tuC"};